export default "__VITE_ASSET__ZphVwTxl__"